import React from 'react';
import { LockIcon, MailIcon } from 'lucide-react';
export const Footer: React.FC = () => {
  return <footer className="bg-gray-900 text-gray-400 py-16 px-4" data-id="element-70">
      <div className="container mx-auto max-w-6xl" data-id="element-71">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-72">
          {/* Column 1 */}
          <div data-id="element-73">
            <div className="flex items-center gap-2 mb-4 text-white" data-id="element-74">
              <LockIcon className="w-5 h-5" data-id="element-75" />
              <h3 className="font-bold text-lg" data-id="element-76">Pago Seguro</h3>
            </div>
            <p className="text-sm mb-6" data-id="element-77">
              Todas las transacciones están protegidas con encriptación SSL de
              256 bits. Tu información está 100% segura.
            </p>
            <div className="flex gap-2 flex-wrap" data-id="element-78">
              <div className="px-2 py-1 bg-gray-800 text-xs rounded border border-gray-700" data-id="element-79">
                VISA
              </div>
              <div className="px-2 py-1 bg-gray-800 text-xs rounded border border-gray-700" data-id="element-80">
                MASTERCARD
              </div>
              <div className="px-2 py-1 bg-gray-800 text-xs rounded border border-gray-700" data-id="element-81">
                PAYPAL
              </div>
            </div>
          </div>

          {/* Column 2 */}
          <div data-id="element-82">
            <h3 className="font-bold text-lg text-white mb-4" data-id="element-83">
              Enlaces Útiles
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-84">
              <li data-id="element-85">
                <a href="#" className="hover:text-white transition-colors" data-id="element-86">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-87">
                <a href="#" className="hover:text-white transition-colors" data-id="element-88">
                  Política de Privacidad
                </a>
              </li>
              <li data-id="element-89">
                <a href="#" className="hover:text-white transition-colors" data-id="element-90">
                  Política de Cookies
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 */}
          <div data-id="element-91">
            <h3 className="font-bold text-lg text-white mb-4" data-id="element-92">Contacto</h3>
            <div className="flex items-center gap-3 text-sm" data-id="element-93">
              <MailIcon className="w-5 h-5" data-id="element-94" />
              <a href="mailto:info@activapleno.com" className="hover:text-white transition-colors" data-id="element-95">
                info@activapleno.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-xs text-center space-y-4" data-id="element-96">
          <p data-id="element-97">
            Este es un producto digital. No se enviará ningún producto físico.
            El acceso se proporciona inmediatamente después de la compra.
          </p>
          <p data-id="element-98">
            © {new Date().getFullYear()} Megapack Folclore Listo. Todos los
            derechos reservados.
          </p>
          <p className="text-gray-600" data-id="element-99">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
};